import { apiUrl } from './api-base';
import { normalizeQuizAnswers } from './quiz-play-storage';

export function submitQuizAttemptKeepalive(
  sessionId: string,
  answers: number[],
  startedAt: string,
  questionCount: number,
  completedAt?: string | null,
  questionStartedAt?: string[],
): void {
  const url = apiUrl(`/api/quiz-sessions/${encodeURIComponent(sessionId)}/attempts`);
  const payload = JSON.stringify({
    answers: normalizeQuizAnswers(answers, questionCount),
    startedAt,
    completedAt: completedAt ?? undefined,
    questionStartedAt: questionStartedAt ?? undefined,
  });

  void fetch(url, {
    method: 'POST',
    credentials: 'include',
    keepalive: true,
    headers: { 'Content-Type': 'application/json' },
    body: payload,
  }).catch(() => {
    // Best-effort on tab close; ignore network errors.
  });
}
